import { SimulatedPropositions } from 'store/customer/types'
import { CounterType, ELProduct, NGProduct, Product, PromoCode, Usage } from '@boltenergy-be/shared'

// TYPES

type DeliveryPoint = {
  postalCode: string
  townCode: string
  townName: string
}

export type ElectricityAndGasPrices = {
  electricity: number
  gas: number
}

export type MeterUsage = Usage

export type Price = {
  total: number
  totalWithoutVAT: number
  vat: number
  totalEnergy: number
  totalInjection?: number
  subscription: number
  transport: number
  discount: number
  injection?: number
}

type Products = {
  electricity?: ELProduct
  gas?: NGProduct
}

export type SimulatePriceRequest = {
  counterType: CounterType
  deliveryPoint: DeliveryPoint
  discountCode?: PromoCode
  hasSolarPanels: boolean
  isCompany: boolean
  meterUsage: Omit<Usage, 'solarKva' | 'grade'>
  product: Products
  solarKva?: number
  walloniaSolarPanelsSince2024?: boolean
}

export type SimulatePriceResponse = {
  price: {
    total: Price
    electricity: Price
    gas?: Price
  }
}

export type KvaInjectionPayload = {
  counterType: CounterType
  hasSolarPanels: boolean
  walloniaSolarPanelsSince2024?: boolean
}

export type PropositionRequestOptions = {
  products?: Product[]
  onSuccess?: (availablePropositions: SimulatedPropositions) => void
  onError?: () => void
}

// ENUMS

export enum SimulationSteps {
  POSTAL_CODE = 'Postal Code',
  ENERGY_TYPE = 'Energy Type',
  USAGE = 'Usage',
  PROPOSITION = 'Proposition'
}
